import React from "react";
import Indusone from "../../images/bg-image/IMG_0089 (1).jpeg";

function OurExpertise() {
  return (
    <div className="w-full">
      {/* Top Section - Image & Text */}
      <div className="mx-auto md:mt-2">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-3 items-stretch">
          {/* Left Side - Text Content */}
          <div className="lg:col-span-5 bg-white text-[#0c2340] p-6 rounded-lg duration-300 ease-in-out flex flex-col justify-center md:h-[400px]">
            <h2 className="text-2xl md:text-4xl font-bold mb-1 md:mb-4 text-center">
              SEALANTS DIVISION
            </h2>
            <p className="text-sm md:text-lg mb-6 text-justify md:mt-2">
              Our Sealants Division is dedicated to providing high-quality, innovative sealing solutions tailored to meet the diverse needs of the construction, automotive, and industrial sectors. We specialize in offering a wide range of silicone, polyurethane, and hybrid sealants that deliver exceptional performance and reliability.

              Whether you're working on commercial construction projects, automotive manufacturing, or heavy-duty industrial applications, our sealants are designed to ensure the highest standards of durability and long-lasting protection. Our products offer superior adhesion, excellent weather resistance, and unmatched flexibility.
            </p>
          </div>

          {/* Right Side - Image */}
          <div className="lg:col-span-7 flex">
            <div className="w-full h-[400px] overflow-hidden rounded-lg">
              <img
                src={Indusone}
                alt="Offshore Industry"
                className="w-full h-full object-cover transition-transform duration-300 ease-in-out hover:scale-110"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OurExpertise;
